import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './../services/auth.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  public constructor(private authService: AuthService) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
    .pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catchError((error: HttpErrorResponse): Observable<any> => {
        if (error.status === 401){
          this.authService.login();
          return of();
        }

        throw error;
      }));
  }
}
